import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';

import { LayoutAside, LayoutBody, LayoutContent } from 'shared/layout';
import { ApplicationModule } from 'shared/modules';
import { UiBackButton, UiDataBoundary, UiDate, UiGrid, UiHtml, UiIcon, UiNavLink, UiTags } from 'shared/uikit';
import { COLORS, ICONS, ROUTES } from 'shared/constants';
import { EssentialModel, NewsModel } from 'shared/models';
import { useNavigate, useRouteParams, useStore, useUserWidgets } from "shared/hooks";
import { essentialsGetQuery } from "shared/queries";

import './styles.scss';

export const EssentialPage = observer(() => {
    const navigate = useNavigate();
    const routeParams = useRouteParams<{ id: number }>();
    const store = useStore(() => ({
        item: new NewsModel(),
        other: [] as NewsModel[],
        isSuccess: true,
        isLoading: true,
    }));

    const fetchItem = useCallback(async () => {
        store.set("isLoading", true);
        const { isSuccess, data } = await essentialsGetQuery(routeParams.id);
        if (isSuccess && data) {
            store.set('item', new EssentialModel(data.item));
            store.set('other', data.other.map(item => new EssentialModel(item)));
            ApplicationModule.setTitle(data.item.name);
        }
        store.set("isSuccess", isSuccess && data);
        store.set("isLoading", false);
    }, [store, routeParams.id]);

    useEffect(() => {
        ApplicationModule.setTitle('...');
    }, [])

    useEffect(() => {
        fetchItem();
    }, [fetchItem]);

    return (
        <LayoutBody>
            <LayoutContent>
                <UiDataBoundary isLoading={store.isLoading} isError={!store.isSuccess}>
                    <UiGrid style={{ display: "block", maxWidth: 1024 }}>
                        <div className="detail-page__back">
                            <UiBackButton label='К важной информации' to={ROUTES.ESSENTIALS()}/>
                        </div>
                        <div className="detail-page__header">
                            <UiDate value={store.item.createdAt}/>
                            <UiTags items={store.item.tags} onClick={({ value }) => {
                                navigate(ROUTES.HOME(), {
                                    tagId: value.id
                                })
                            }}/>
                        </div>
                        <div className='essential-detail typography'>
                            <h1>{store.item.name}</h1>
                            <div>
                                {store.item.detailImage && (
                                    <img
                                        className='essential-detail__image'
                                        src={store.item.detailImage}
                                        alt={store.item.name}
                                    />
                                )}
                                <UiHtml value={store.item.detailText}/>
                            </div>
                        </div>
                        {store.other.length > 0 && (
                            <div className="detail-page-other">
                                <div className="detail-page-other__title">Читайте так же:</div>
                                <div className="detail-page-other__items">
                                    {store.other.map(item => (
                                        <UiNavLink
                                            to={ROUTES.ESSENTIAL(item.id)}
                                            key={item.id}
                                            className='detail-page-other-item'
                                        >
                                            <div className="detail-page-other-item__icon">
                                                <UiIcon icon={ICONS.CIRCLE} color={COLORS.BROWN_1} size={10}/>
                                            </div>
                                            <div className="detail-page-other-item__name">{item.name}</div>
                                        </UiNavLink>
                                    ))}
                                </div>
                            </div>
                        )}
                    </UiGrid>
                </UiDataBoundary>
            </LayoutContent>
            <LayoutAside widgets={useUserWidgets()}/>
        </LayoutBody>
    );
})
